import React from 'react';
import styled from 'styled-components';
import Bivalves from '../../components/Bivalves/Bivalves';
import Target from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:300px;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 60vh;

  }
`;



class CardBivalves extends React.Component {
  render () {
   return (

<Container>
    
    <Viz>
      <Bivalves />

    </Viz>

   <ReusableDetailCard
   trend= {Target}
   metricsm="Prevalent Globally"
   diagnosis="Bivalve mollusks filter food through their gills. Heavy metals and toxin-laden microplastics can accumulate in the digestive tract. This  starves the organism and makes it unsafe for human consumption. "
   prediction="Bivalves serve as habitat and prey for a variety of sea life. In 2011, NOAA estimated the economic value of commercial bivalve mollusk harvesting at about $1 billion annually in the U.S."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
</Container>

  );
 }
}

export default CardBivalves;
